import React from "react";
import { Skeleton } from "@mui/material";

export function DataSkeleton() {
  return (
    <Skeleton variant="rounded" width="100%" height="60px" sx={{ p: "16px" }} />
  );
}
